import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { GITLAB_PATHS } from './paths';

/** GitLab платформы: знак «танука» (Simple Icons, CC0). */
export const GitlabIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {GITLAB_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
